import { CardShell } from '@/src/components/global/card-shell/CardShell'
import { FamilyCardHeader } from '@/src/components/global/family-card/family-card-header/FamilyCardHeader'
import CardScore from '@/src/components/global/card-score/CardScore'
import { useTranslation } from 'react-i18next'
import { FamilyDto } from '@/infra/api/generated/model'

interface TeamFamilyCardProps {
  userId: string
  family: FamilyDto
  score: number
  diagnosisId: string
  daysLeft?: number | null
  onClick: (diagnosisId: string) => void
}

const TeamFamilyCard = ({
  userId,
  family,
  score,
  diagnosisId,
  daysLeft = 0,
  onClick,
}: TeamFamilyCardProps) => {
  const { t } = useTranslation('common')
  const displayText = [
    userId,
    daysLeft != null && t('pages.my-team.history.days-left', { count: daysLeft }),
  ]
    .filter(Boolean)
    .join(' - ')

  return (
    <button
      data-testid="team-family-card-button"
      type="button"
      className="text-start"
      onClick={() => onClick(diagnosisId)}
    >
      <CardShell className="gap-2">
        <FamilyCardHeader family={family} />
        <div className="flex justify-between items-center">
          <p className="text-neutral-500 text-sm">{displayText}</p>
          <div className="ml-auto">
            <CardScore score={score} />
          </div>
        </div>
      </CardShell>
    </button>
  )
}

export default TeamFamilyCard
